import { useQuery } from "@tanstack/react-query";
import { CacheKey } from "../models/cacheKey";
import { Response } from "../models/response";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";
import type { ISecurityPledgeResponse } from "../models/securityPledge";

export function useSecurityPledge() {
	const {
		data: securityPledge,
		isLoading,
		isError,
		error,
	} = useQuery({
		queryKey: [CacheKey.getSecurityPledge],
		queryFn: async () => {
			const response = new Response<ISecurityPledgeResponse>(
				await HttpClient.request(OnSiteApi.getSecurityPledge()),
			);
			return response.data;
		},
		staleTime: 0,
		gcTime: 0,
	});

	return { securityPledge: securityPledge, isLoading, isError, error };
}
